/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSquarePlus = createReactComponent("outline", "square-plus", "IconSquarePlus", [["path", { "d": "M9 12h6", "key": "svg-0" }], ["path", { "d": "M12 9v6", "key": "svg-1" }], ["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-2" }]]);

export { IconSquarePlus as default };
//# sourceMappingURL=IconSquarePlus.mjs.map
